import React from 'react';
import SectionTitle from '../components/SectionTitle';
import RequestForm from '../components/RequestForm';

export default function SubmitRequest() {
  return (
    <div className="pt-16">
      <SectionTitle 
        title="Submit Capital Request" 
        subtitle="Tell us about your investment opportunity" 
      />
      <div className="max-w-2xl mx-auto px-6 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <RequestForm />
        </div>
      </div>
    </div>
  );
} 